import Markdown from 'markdown-to-jsx'

// Config
import md2jsxOptions from 'config/md2jsx'

//
export default function MarkdownDefault({ children }) {
	return <Markdown options={md2jsxOptions}>{children}</Markdown>
}
